/*
 * air-sold-out.js — sync Buy Now / Sold Out CTA state across converted pages.
 * Supports Replo dual-button pattern (.r-1ua20d4) and single-button text swap.
 * Reads variant availability from page JSON blobs; hooks form variant-id changes.
 */
(function () {
  'use strict';
  if (window.__airSoldOutInit) return;
  window.__airSoldOutInit = true;

  function soldOutHtml() {
    return (window.AirI18n && window.AirI18n.soldOutHtml) || '<p>Sold Out</p>';
  }
  var variantAvail = Object.create(null);
  var mainAvailable = null;

  function parseJson(id) {
    var el = document.getElementById(id);
    if (!el) return null;
    try {
      return JSON.parse(el.textContent);
    } catch (e) {
      return null;
    }
  }

  function indexVariants(list) {
    if (!Array.isArray(list)) return;
    list.forEach(function (v) {
      if (v && v.id != null) variantAvail[v.id] = !!v.available;
    });
  }

  function buildVariantMap() {
    indexVariants(parseJson('air-cpro-variants'));
    indexVariants(parseJson('air-variant-data'));

    ['air-tens-variant-data', 'air-elite-variant-data'].forEach(function (id) {
      var d = parseJson(id);
      if (!d) return;
      if (d.defaultId != null && d.defaultAvailable != null) {
        variantAvail[d.defaultId] = !!d.defaultAvailable;
      }
      if (d.byValue && d.byAvailable) {
        Object.keys(d.byValue).forEach(function (key) {
          var vid = d.byValue[key];
          if (vid != null && d.byAvailable[key] != null) {
            variantAvail[vid] = !!d.byAvailable[key];
          }
        });
      }
    });

    var bb = parseJson('air-airpro-buybox-data');
    if (bb) {
      mainAvailable = !!bb.mainAvailable;
      if (bb.mainId != null) variantAvail[bb.mainId] = mainAvailable;
    }

    var deps = parseJson('air-deps-products');
    if (Array.isArray(deps)) {
      deps.forEach(function (entry) {
        var data = entry && entry.data;
        if (data && Array.isArray(data.variants)) indexVariants(data.variants);
      });
    }
  }

  function isAvailable(variantId) {
    if (variantId == null || variantId === '') return mainAvailable != null ? mainAvailable : true;
    var id = parseInt(variantId, 10);
    // variantAvail is a null-prototype object (no .hasOwnProperty method),
    // so guard membership via Object.prototype.hasOwnProperty.call.
    var has = Object.prototype.hasOwnProperty;
    if (has.call(variantAvail, id)) return variantAvail[id];
    if (has.call(variantAvail, String(id))) return variantAvail[String(id)];
    return true;
  }

  function hasDualPattern(container) {
    return !!(
      container.querySelector('.r-fpmnbv') &&
      (container.querySelector('.r-14zktj9') || container.querySelector('.r-1z003ea'))
    );
  }

  function findDualWrap(container) {
    return (
      container.querySelector('.r-fgblly') ||
      container.querySelector('[data-rid="94e7cfeb-c5d6-448f-b533-2839d47897a8"]') ||
      (container.querySelector('.r-fpmnbv') && container.querySelector('.r-fpmnbv').parentElement) ||
      container
    );
  }

  function storeOrigLabel(btn) {
    if (!btn.__airOrigLabel) btn.__airOrigLabel = btn.innerHTML.trim();
  }

  function syncSingleBtn(btn, available) {
    storeOrigLabel(btn);
    if (available) {
      btn.innerHTML = btn.__airOrigLabel;
      btn.removeAttribute('aria-disabled');
      btn.classList.remove('air-cta-sold-out');
      btn.style.pointerEvents = '';
      btn.style.cursor = 'pointer';
    } else {
      btn.innerHTML = soldOutHtml();
      btn.setAttribute('aria-disabled', 'true');
      btn.classList.add('air-cta-sold-out');
      btn.style.pointerEvents = 'none';
      btn.style.cursor = 'not-allowed';
    }
  }

  function syncContainer(container, forceAvailable) {
    if (!container) return;
    var form = container.querySelector('form[action*="/cart/add"]');
    var idInput = form && form.querySelector('input[name="id"]');
    var variantId = idInput && idInput.value;
    var available =
      forceAvailable != null ? !!forceAvailable : isAvailable(variantId);

    if (hasDualPattern(container)) {
      findDualWrap(container).classList.toggle('r-1ua20d4', !available);
      container.querySelectorAll('button.r-1z003ea').forEach(function (btn) {
        if (available) {
          btn.removeAttribute('aria-disabled');
          btn.style.pointerEvents = '';
          btn.classList.remove('air-cta-sold-out');
        } else {
          btn.setAttribute('aria-disabled', 'true');
          btn.style.pointerEvents = 'none';
        }
      });
    }

    container
      .querySelectorAll('[data-replo-add-product-variant-to-cart]')
      .forEach(function (btn) {
        syncSingleBtn(btn, available);
      });
  }

  function syncOrphans() {
    document
      .querySelectorAll('[data-replo-add-product-variant-to-cart]')
      .forEach(function (btn) {
        if (btn.closest('[data-replo-product-container]')) return;
        var avail = mainAvailable != null ? mainAvailable : true;
        syncSingleBtn(btn, avail);
      });
  }

  function syncAll() {
    buildVariantMap();
    document.querySelectorAll('[data-replo-product-container]').forEach(function (c) {
      syncContainer(c);
    });
    syncOrphans();
  }

  function syncScope(scope) {
    buildVariantMap();
    (scope || document).querySelectorAll('[data-replo-product-container]').forEach(function (c) {
      syncContainer(c);
    });
    syncOrphans();
  }

  function hookFormInputs() {
    document.querySelectorAll('form[action*="/cart/add"] input[name="id"]').forEach(function (inp) {
      if (inp.__airSoldOutHook) return;
      inp.__airSoldOutHook = true;
      var run = function () {
        var container = inp.closest('[data-replo-product-container]') || document;
        syncContainer(container);
      };
      inp.addEventListener('change', run);
      inp.addEventListener('input', run);
    });
  }

  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  buildVariantMap();

  window.AirSoldOut = {
    syncAll: syncAll,
    syncScope: syncScope,
    syncContainer: syncContainer,
    syncSingleBtn: syncSingleBtn,
    isAvailable: isAvailable,
    setMainAvailable: function (v) {
      mainAvailable = !!v;
      syncAll();
    },
  };

  ready(function () {
    syncAll();
    hookFormInputs();
  });
})();
